"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPlaceholder = void 0;
const React = require("react");
const _ = require("lodash");
const Button_1 = require("../../atoms/Button");
// TODO: move this to the main theme
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const Modal_1 = require("../Modal");
const css = (0, cssComposer_1.default)(styles, "errorHandler");
if (!_.has(env, "helpEmail")) {
    throw new Error("missing env.helpEmail");
}
/**
 * Provides a consistent way of displaying an error to the user and allowing
 * them to resolve it.
 */
const ErrorPlaceholder = ({ retry, retryLabel = "Try again", title = "Something went wrong", description, inModal = false, showSupportContact = true, canDismiss = true, inModalClose = null }) => {
    // move the title to the modal header
    const msgTitle = inModal ? null : title;
    const ErrorMsg = () => (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("container") },
            !!msgTitle && React.createElement("h3", { className: css("title") }, msgTitle),
            !!description && React.createElement("p", { className: css("description") }, description),
            showSupportContact && (React.createElement("p", null,
                retry
                    ? "Please try again. "
                    : "Please try refreshing the window later. ",
                "If the problem persists we would appreciate if you could notify us of the issue via",
                React.createElement("br", null),
                React.createElement("a", { href: `mailto:${env.helpEmail}` }, env.helpEmail))),
            canDismiss && retry && (React.createElement("div", { className: css("retry"), "data-test": "retry-btn" },
                React.createElement(Button_1.Button, { onClick: retry }, retryLabel))))));
    return inModal ? (React.createElement(Modal_1.Modal, { open: true, onClose: inModalClose },
        React.createElement(Modal_1.ModalHeader, null, title),
        React.createElement(Modal_1.ModalBody, null,
            React.createElement(ErrorMsg, null)))) : (React.createElement(ErrorMsg, null));
};
exports.ErrorPlaceholder = ErrorPlaceholder;
exports.default = exports.ErrorPlaceholder; // TODO: remove this, for legacy imports
//# sourceMappingURL=index.js.map